module.exports = __webpack_public_path__ + "static/media/cover_abi_mathe_lineare_algebra_stochastik.1709d534.jpg";